import * as types from './mutation-types'

export const switchAdvanced = ({ commit }, payload) => {
  commit(types.SWITCH_ADVANCED, payload)
}

export const filterAdvanced = ({ commit }, payload) => {
  commit(types.FILTER_ADVANCED, payload)
}

export const filterNormal = ({ commit }, payload) => {
  commit(types.FILTER_NORMAL, payload)
}

export const setSortObj = ({ commit }, payload) => {
  commit(types.SET_SORTOBJ, payload)
}

export const reset = ({ commit }) => {
  commit(types.RESET)
}

export const initList = ({ commit }, payload) => {
  commit(types.INITLIST, payload)
}

export const increaseSelect = ({ commit }, payload) => {
  commit(types.INCREASE_SELECT, payload)
}

export const decreaseSelect = ({ commit }, payload) => {
  commit(types.DECREASE_SELECT, payload)
}

export const updateSelect = ({ commit }, payload) => {
  commit(types.UPDATE_SELECT, payload)
}

export const updateSelectrows = ({ commit }, payload) => {
  commit(types.UPDATE_SELECTROWS, payload)
}

// 更新业绩目标指标列表
export const updatePerformanceNav = ({ commit }, payload) => {
  commit(types.UPDATE_PERFORMANCE_NAV, payload)
}

export const selecedtAll = ({ commit }, payload) => {
  commit(types.SELECT_ALL, payload)
}

export const cancelAll = ({ commit }, payload) => {
  commit(types.CANCEL_ALL, payload)
}

export const setAttr = ({ commit }, payload) => {
  setTimeout(() => {
    commit(types.ASYNC_VALIDATE, payload)
  }, 100)
}

export const updateRemindCount = ({ commit }, payload) => {
  commit(types.UPDATE_REMINDCOUNT, payload)
}

export const setErrorCode = ({ commit }, payload) => {
  commit(types.ERROR_CODE, payload)
}

export const setDetailConfig = ({ commit }, payload) => {
  commit(types.DETAIL_CONFIG, payload)
}

export const setListLoading = ({ commit }, payload) => {
  commit(types.LIST_LOADING, payload)
}

export const setSidemenuStatus = ({ commit }, payload) => {
  commit(types.SIDEMENU_STATUS, payload)
}

export const setUpdateAddress = ({ commit }) => {
  commit(types.UPDATE_ADDRESS)
}

export const setSpecialEnmus = ({ commit }, payload) => {
  commit(types.SPECIAL_ENMUS, payload)
}

// 扫码+1所在行序号
export const updateAddNumIndex = ({ commit }, payload) => {
  commit(types.UPDATE_ADDNUMINDEX, payload)
}

// 列表页码
export const updateVuexPage = ({ commit }, payload) => {
  commit(types.UPDATE_VUEXPAGE, payload)
}

export const setAliasList = ({ commit }, payload) => {
  commit(types.SET_ALIAS_LIST, payload)
}

export const setFreshAllList = ({ commit }, payload) => {
  commit(types.SET_FRESH_ALL_LIST, payload)
}


// WEBPACK FOOTER //
// ./src/store/actions.js